import React, { useState } from 'react';
import WaterWave from 'react-water-wave';
import Spacing from '../Spacing';
import parse from 'html-react-parser';
import './VideoModal.css';

export default function VideoModal({ videoSrc, bgUrl, title, titleVariant }) {
  const [isPlaying, setIsPlaying] = useState(false);

  const handleClick = () => {
    setIsPlaying(!isPlaying);
  };

  return (
    <>
      {title && (
        <>
          <h2 className={`cs_video_block_1_title cs_fs_68 text-center mb-0 ${titleVariant ? titleVariant : 'text-uppercase'}`}>
            {parse(title)}
          </h2>
          <Spacing lg="80" md="45" />
        </>
      )}
      
      <div className="cs_video_container">
        {!isPlaying ? (
          <WaterWave
            className="cs_video_block cs_style_1 cs_bg_filed cs_radius_15 position-relative d-flex justify-content-center align-items-center cs_ripple_activate overflow-hidden"
            imageUrl={bgUrl}
          >
            {() => (
              <span className="cs_hero_video_icon" onClick={handleClick}>
                <svg width={80} height={80} viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx={40} cy={40} r={40} fill="#FD6219" />
                  <path d="M60.079 39.9998L30.148 57.4394L30.0104 22.7986L60.079 39.9998Z" fill="white" />
                </svg>
              </span>
            )}
          </WaterWave>
        ) : (
          <div className="video-wrapper">
            <iframe
              src={`${videoSrc}?autoplay=1`}
              title="Video"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <button 
              onClick={handleClick}
              className="video-close-btn"
            >
              ×
            </button>
          </div>
        )}
      </div>
    </>
  );
}
